import React, { useEffect, useState } from "react";
import "./loginCard.css";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { signIn, twoFactorAuthentication } from "../../services/authService";
import { useContext } from "react";
import AuthContext from "../../store/AuthContext";
import InteliIcon from "../../assets/image001.png";

function LoginCard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (authCtx.isLoggedIn) navigate("/");
    // eslint-disable-next-line
  }, [authCtx]);

  const signInUser = async () => {
    setLoading(true);

    if (email === "") {
      toast("User ID is required");
      setLoading(false);
      return;
    }

    if (password === "") {
      toast("Password is required");
      setLoading(false);
      return;
    }

    try {
      const res = await signIn({ email, password });
      if (res?.status === "success") {
        if (res.data.twoFactorAuth === false) {
          const response = await twoFactorAuthentication();

          setLoading(false);

          if (res?.data?.defaultPrompt) {
            localStorage.setItem(
              "defaultPromptNew",
              JSON.stringify(res?.data?.defaultPrompt)
            );
          } else {
            localStorage.removeItem("defaultPromptNew");
          }

          navigate("/twoFactorAuthentication", {
            state: {
              enabled: false,
              email: email,
              secret: response.secret,
              qrCode: response.qrCode,
            },
          });
        } else {
          if (res?.data?.defaultPrompt) {
            localStorage.setItem(
              "defaultPromptNew",
              JSON.stringify(res?.data?.defaultPrompt)
            );
          } else {
            localStorage.removeItem("defaultPromptNew");
          }

          navigate("/twoFactorAuthentication", {
            state: {
              enabled: true,
              email: res.data.email,
            },
          });
        }
      } else throw new Error("Sign Up Failed");
    } catch (e) {
      setLoading(false);

      console.log("  e?.response?.data?.message", e?.response?.data?.message);

      toast(
        e?.response?.data?.message
          ? e?.response?.data?.message
          : "An error occured. Please try again"
      );
    }
  };

  return (
    <div className=" loginContainer container ">
      <img
        src={InteliIcon}
        style={{ height: "90px", width: "140px", alignSelf: "center" }}
      />
      <ToastContainer />
      <div className="loginCardWrapper">
        <div>
          <span className="loginCardTitle">Login</span>
        </div>

        <span className="title">User Id</span>

        <input
          style={{ padding: "10px" }}
          type="text"
          value={email}
          placeholder="Enter your User ID"
          onChange={(e) => setEmail(e.target.value)}
          className="emailInput"
        />

        <span className="title">Password </span>
        <div className="passwordInputWrapper">
          <div className="passwordInputInnerWrapper">
            <input
              style={{ padding: "10px" }}
              type={showPassword ? "text" : "password"}
              value={password}
              onKeyDown={(e) => {
                if (e.code === "Enter") {
                  signInUser();
                }
              }}
              placeholder="Enter your password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className={`eye-icon ${showPassword ? "visible" : ""}`}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
            </span>
          </div>
        </div>

        {loading === false ? (
          <div>
            <button
              className="loginButton"
              onClick={() => {
                signInUser();
              }}
            >
              Login
            </button>
          </div>
        ) : (
          <div>
            <button className="loginButton">Loading ... </button>
          </div>
        )}
        <div></div>
      </div>
    </div>
  );
}

export default LoginCard;
